import {
  AccountOptionDto,
  Configuration,
  ControllerDedicatoAFunzioniSoloPerAmministratoriApi,
  CreateUpdateAccountStrutturaBusinessDto,
  DeleteAccountStrutturaBusinessRequest,
  SaveAccountStrutturaBusinessRequest,
} from '@api/client';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'core/store';
import getConfiguration, { errorHandler } from 'core/store/config';

enum AccountStrutturaBusinessActions {
  saveAssociation = '[AccountStrutturaBusiness] Save Association',
  listByStruttura = '[AccountStrutturaBusiness] List By Struttura',
  listAllAccounts = '[AccountStrutturaBusiness] List All Accounts',
  deleteAssociation = '[AccountStrutturaBusiness] Delete Association',
}

export const saveAccountStrutturaBusinessAssociation = createAsyncThunk<
  CreateUpdateAccountStrutturaBusinessDto | undefined,
  SaveAccountStrutturaBusinessRequest,
  ThunkApiConfig
>(AccountStrutturaBusinessActions.saveAssociation, async (payload, { dispatch, extra, getState }) => {
  try {
    return await new ControllerDedicatoAFunzioniSoloPerAmministratoriApi(
      getConfiguration(Configuration, extra, getState),
    ).saveAccountStrutturaBusiness(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

// Lo swagger tipizza la risposta come AccountOptionDto singolo ma il BE restituisce un array.
// Bypassiamo il mapping generato leggendo direttamente la Response JSON.
export const getAccountsByStruttura = createAsyncThunk<AccountOptionDto[], number, ThunkApiConfig>(
  AccountStrutturaBusinessActions.listByStruttura,
  async (idStruttura, { dispatch, extra, getState }) => {
    try {
      const raw = await new ControllerDedicatoAFunzioniSoloPerAmministratoriApi(
        getConfiguration(Configuration, extra, getState),
      ).getAccountsByStrutturaRaw({ idStruttura });
      const json = await raw.raw.json();
      return Array.isArray(json) ? (json as AccountOptionDto[]) : [];
    } catch (e) {
      errorHandler(e, dispatch, getState);
      return [];
    }
  },
);

export const getAllAccountStrutturaBusiness = createAsyncThunk<AccountOptionDto[], void, ThunkApiConfig>(
  AccountStrutturaBusinessActions.listAllAccounts,
  async (_, { dispatch, extra, getState }) => {
    try {
      const raw = await new ControllerDedicatoAFunzioniSoloPerAmministratoriApi(
        getConfiguration(Configuration, extra, getState),
      ).getAllAccountStrutturaBusinessRaw();
      const json = await raw.raw.json();
      return Array.isArray(json) ? (json as AccountOptionDto[]) : [];
    } catch (e) {
      errorHandler(e, dispatch, getState);
      return [];
    }
  },
);

export const deleteAccountStrutturaBusinessAssociation = createAsyncThunk<
  void,
  DeleteAccountStrutturaBusinessRequest,
  ThunkApiConfig
>(AccountStrutturaBusinessActions.deleteAssociation, async (payload, { dispatch, extra, getState }) => {
  try {
    await new ControllerDedicatoAFunzioniSoloPerAmministratoriApi(
      getConfiguration(Configuration, extra, getState),
    ).deleteAccountStrutturaBusiness(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});
